import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState, type ReactNode } from 'react';
import { useAuth } from '../providers/AuthProvider.js';
import { PageSkeleton } from '@shared/ui/PageSkeleton/PageSkeleton.js';
import { useToast } from '@shared/ui/Toast/Toast.js';
import { ROUTES } from '@shared/config/constants.js';
import { goToIamAuth } from '@shared/api/silentAuth.js';

interface Props {
  children: ReactNode;
}

export function AdminRoute({ children }: Props) {
  const { status, session } = useAuth();
  const { showToast } = useToast();
  const location = useLocation();
  const [blocked, setBlocked] = useState(false);

  // No in-memory session (cold load / reload / expiry) → try a silent re-authorize against the
  // IAM, returning to THIS exact path. If the loop guard suppresses it, fall back to manual login.
  useEffect(() => {
    if (status === 'unauthenticated') {
      const attempted = goToIamAuth(location.pathname + location.search);
      if (!attempted) setBlocked(true);
    }
  }, [status, location.pathname, location.search]);

  if (status === 'loading') return <PageSkeleton />;
  if (status === 'unauthenticated') {
    return blocked ? <Navigate to={ROUTES.login} replace /> : <PageSkeleton />;
  }
  if (session?.user.role !== 'admin') {
    showToast({ kind: 'error', message: 'No tenés permisos para esta acción' });
    return <Navigate to={ROUTES.home} replace />;
  }
  return <>{children}</>;
}
